// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SnsWhatsApp from '../_raw/ui/icon_sns_whats_app.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SnsWhatsApp);
